<template>
    <VideoProjectDashboard
        :show="state.showProjectExplorer"
        @close="state.showProjectExplorer = false"
        @select="selectProject"
    ></VideoProjectDashboard>
    <VideoClipSetting
        :clip="state.selectedClip?.data"
        :show="state.showClipSetting"
        @close="state.showClipSetting = false"
        @update="updateclip"
    ></VideoClipSetting>
    <div class="h-[100vh] overflow-hidden select-none pt-2 border-1 gap-0">
        <div
            class="
                flex
                items-center
                justify-between
                px-6
                pb-2
                mb-4
                border-b border-[#E9EBF0]
            "
        >
            <div
                class="flex items-center gap-2"
                @click="state.showProjectExplorer = true"
            >
                <div class="rounded-lg overflow-hidden">
                    <img src="/default-images/team.png" class="h-[30px]" />
                </div>
                <span v-if="state.project">
                    {{ state.project.name }}
                </span>
                <span v-else> Select a project... </span>
            </div>
            <VideoProjectExport
                :project-id="state.project?.id"
            ></VideoProjectExport>
        </div>
        <div class="flex items-start h-full">
            <div class="flex flex-col gap-5 sidebar items-start pt-10">
                <button
                    @click="state.currentTab = 'video'"
                    :class="{
                        active: state.currentTab === 'video',
                    }"
                >
                    <div class="text-[25px]">
                        <ion-icon name="videocam-outline"></ion-icon>
                    </div>
                    <span>Video</span>
                </button>
                <button
                    @click="state.currentTab = 'audio'"
                    :class="{
                        active: state.currentTab === 'audio',
                    }"
                >
                    <div class="text-[25px]">
                        <ion-icon name="musical-notes-outline"></ion-icon>
                    </div>
                    <span>Audio</span>
                </button>
                <button
                    @click="state.currentTab = 'shape'"
                    :class="{
                        active: state.currentTab === 'shape',
                    }"
                >
                    <div class="text-[25px]">
                        <ion-icon name="shapes-outline"></ion-icon>
                    </div>
                    <span>Shape</span>
                </button>
            </div>

            <div
                class="panel rounded-lg h-[calc(100%-10px)] mr-4"
                v-if="state.currentTab === 'video'"
            >
                <div
                    class="
                        flex
                        justify-between
                        items-center
                        pl-5
                        pr-2
                        py-2
                        border-b border-[#E9EBF0]
                        min-w-[300px]
                    "
                >
                    <div class="flex items-center gap-2">
                        <div
                            class="text-[20px] flex items-center justify-center"
                        >
                            <ion-icon name="videocam-outline"></ion-icon>
                        </div>
                        <span class="text-[16px] font-bold">Videos</span>
                    </div>
                    <button
                        class="text-[20px] leading-none button-back"
                        @click="state.currentTab = ''"
                    >
                        <ion-icon name="chevron-back-outline"></ion-icon>
                    </button>
                </div>

                <video-project-explorer
                    @videodrag="onDragResourceStart"
                    @videodrop="onDropResource"
                    @dblclick="onVideoClick"
                ></video-project-explorer>
            </div>

            <div
                class="panel rounded-lg h-[calc(100%-10px)] mr-4"
                v-if="state.currentTab === 'audio'"
            >
                <div
                    class="
                        flex
                        justify-between
                        items-center
                        pl-5
                        pr-2
                        py-2
                        border-b border-[#E9EBF0]
                        min-w-[300px]
                    "
                >
                    <div class="flex items-center gap-2">
                        <div
                            class="text-[20px] flex items-center justify-center"
                        >
                            <ion-icon name="videocam-outline"></ion-icon>
                        </div>
                        <span class="text-[16px] font-bold">Audios</span>
                    </div>
                    <button
                        class="text-[20px] leading-none button-back"
                        @click="state.currentTab = ''"
                    >
                        <ion-icon name="chevron-back-outline"></ion-icon>
                    </button>
                </div>

                <audio-project-explorer
                    :audios="state.audios"
                    @audiodrag="onDragResourceStart"
                    @audiodrop="onDropResource"
                    @dblclick="onAudioClick"
                    @updated="(data) => (state.audios = data)"
                ></audio-project-explorer>
            </div>
            <div
                class="panel rounded-lg h-[calc(100%-10px)] mr-4"
                v-if="state.currentTab === 'shape'"
            >
                <div
                    class="
                        flex
                        justify-between
                        items-center
                        pl-5
                        pr-2
                        py-2
                        border-b border-[#E9EBF0]
                        min-w-[300px]
                    "
                >
                    <div class="flex items-center gap-2">
                        <div
                            class="text-[20px] flex items-center justify-center"
                        >
                            <ion-icon name="videocam-outline"></ion-icon>
                        </div>
                        <span class="text-[16px] font-bold">Shapes</span>
                    </div>
                    <button
                        class="text-[20px] leading-none button-back"
                        @click="state.currentTab = ''"
                    >
                        <ion-icon name="chevron-back-outline"></ion-icon>
                    </button>
                </div>
                <div>
                    <button @click="drawCircle">Circle</button>
                </div>
            </div>

            <audio
                class="h-full w-full"
                ref="projectAudioRefs"
                :src="audio.url"
                v-for="audio in state.audioClips"
                :key="audio.id"
            ></audio>
            <splitpanes class="default-theme" horizontal>
                <pane size="60" style="position: relative; padding-right: 20px">
                    <div
                        class="
                            rounded-[12px]
                            bg-[#F3F4F7]
                            w-full
                            h-full
                            flex flex-col
                            p-[20px]
                        "
                    >
                        <div
                            class="h-[calc(100%-74px)] relative"
                            id="videoWrapper"
                        >
                            <div
                                class="
                                    absolute
                                    border-solid border-2 border-[#FE853A]
                                    max-w-[100%]
                                    overflow-hidden
                                    z-[100]
                                    top-0
                                    left-[50%]
                                "
                                id="holder"
                                ref="holder"
                                :style="{
                                    height: propHeight + 'px',
                                    width: propWidth && propWidth + 'px',
                                }"
                            ></div>
                            <video
                                class="h-full w-full"
                                ref="projectVideoRefs"
                                :src="video.url"
                                v-for="(video, index) in state.videoClips"
                                :key="video.id"
                                :style="`display: ${
                                    state.activeVideo == index
                                        ? 'block'
                                        : 'none'
                                }`"
                            ></video>
                        </div>
                        <div
                            class="
                                flex
                                justify-center
                                items-center
                                text-[32px]
                                gap-6
                                text-[#4a4a4a]
                                mt-[20px]
                            "
                        >
                            <button @click="seek(0)">
                                <ion-icon
                                    name="play-skip-back-circle"
                                ></ion-icon>
                            </button>
                            <button @click="onPlayerPlay()">
                                <ion-icon
                                    name="play"
                                    v-if="!state.player.isPlaying"
                                ></ion-icon>
                                <ion-icon
                                    name="pause"
                                    v-if="state.player.isPlaying"
                                ></ion-icon>
                            </button>
                            <button @click="seek(state.videoTimelineEnd)">
                                <ion-icon
                                    name="play-skip-forward-circle"
                                ></ion-icon>
                            </button>
                        </div>
                    </div>
                </pane>

                <pane
                    size="40"
                    style="
                        position: relative;
                        padding-bottom: 10px;
                        border-top-left-radius: 12px;
                        border-bottom-left-radius: 12px;
                        background: #f3f4f7;
                    "
                >
                    <div class="flex justify-between items-center px-4 py-4">
                        <div class="flex text-[18px] gap-4">
                            <button @click="removeAll">
                                <ion-icon name="trash-outline"></ion-icon>
                            </button>
                            <button
                                @click="removeClip"
                                v-show="state.selectedClip"
                            >
                                <ion-icon name="trash-bin-outline"></ion-icon>
                            </button>
                            <button
                                @click="editClip"
                                v-show="state.selectedClip"
                            >
                                <ion-icon name="cut-outline"></ion-icon>
                            </button>
                        </div>
                        <div class="flex gap-2">
                            <span>{{
                                formatTime(state.timelinePosition)
                            }}</span>
                            <span class="text-gray-400">/</span>
                            <span class="text-gray-400">{{
                                formatTime(timelineEnd)
                            }}</span>
                        </div>
                        <div class="flex gap-2 text-[18px]">
                            <button @click="state.zoom -= 0.1">
                                <ion-icon name="remove-outline"></ion-icon>
                            </button>
                            <button @click="state.zoom += 0.1">
                                <ion-icon name="add-outline"></ion-icon>
                            </button>
                        </div>
                    </div>
                    <div
                        id="thumb"
                        class="
                            absolute
                            flex flex-col
                            justify-center
                            h-full
                            items-center
                            top-[45px]
                            z-[200]
                        "
                        :style="`left:${
                            state.timelinePosition *
                            state.timelineSizePx *
                            state.zoom
                        }px;`"
                    >
                        <div
                            class="
                                h-[10px]
                                bg-[#15B66E]
                                w-[10px]
                                cursor-pointer
                            "
                        ></div>
                        <div class="h-full bg-[#15B66E] w-[2px]"></div>
                    </div>
                    <div
                        class="
                            border-t-[1px] border-t-[#d8d7d7]
                            w-full
                            flex
                            mt-2
                        "
                    ></div>
                    <div
                        class="
                            overflow-x-scroll
                            h-[calc(100%-57px)]
                            absolute
                            w-full
                            px-2
                        "
                        @drop="onDropResource"
                        @dragover.prevent
                    >
                        <div
                            class="flex cursor-pointer"
                            :style="`gap:${
                                state.timelineSizePx * state.zoom
                            }px`"
                            @click="onTimelineClick"
                        >
                            <div
                                v-for="layer in state.timelineFrame"
                                :key="layer.order"
                                class="
                                    w-[1px]
                                    h-[10px]
                                    bg-[#d8d7d7]
                                    flex-shrink-0
                                "
                            >
                                <div
                                    class="text-[10px] text-gray-500"
                                    v-if="layer % 5 === 0"
                                >
                                    {{ layer }}
                                </div>
                            </div>
                        </div>

                        <div class="top-10 flex gap-1 absolute">
                            <div
                                class="
                                    rounded-lg
                                    gap-2
                                    h-[40px]
                                    bg-[#9F77EE]
                                    flex
                                    items-center
                                    px-4
                                    cursor-pointer
                                "
                                @click="selectClip(video, 'video')"
                                :style="`
border: 2px solid ${isClipSelected(video, 'video') ? 'white' : '#9F77EE'};
outline: 1px solid #9F77EE;
position: absolute;
width: ${getClipWidth(video)}px;
left: ${getClipPosition(video)}px;
`"
                                v-for="video in state.videoClips"
                                :key="video.id"
                            >
                                <div
                                    class="
                                        flex
                                        gap-2
                                        items-center
                                        text-white
                                        max-w-[calc(100%-71px)]
                                    "
                                >
                                    <ion-icon
                                        name="play-circle-outline"
                                    ></ion-icon>
                                    <div
                                        class="
                                            text-white text-ellipsis
                                            whitespace-nowrap
                                            overflow-hidden
                                        "
                                    >
                                        {{ video.title }}
                                    </div>
                                </div>
                                <div
                                    class="
                                        text-white
                                        rounded-lg
                                        bg-[#6942C7]
                                        px-2
                                        py-1
                                    "
                                >
                                    {{ formatTime(video.duration) }}
                                </div>
                            </div>
                        </div>
                        <div class="top-24 flex gap-1 absolute">
                            <div
                                class="
                                    rounded-lg
                                    gap-2
                                    h-[40px]
                                    bg-[#FE853A]
                                    flex
                                    items-center
                                    px-4
                                    cursor-pointer
                                "
                                @click="selectClip(audio, 'audio')"
                                :style="`
border: 2px solid ${isClipSelected(audio, 'audio') ? 'white' : '#FE853A'};
outline: 1px solid #FE853A;
position: absolute;
width: ${getClipWidth(audio)}px;
left: ${getClipPosition(audio)}px;
`"
                                v-for="audio in state.audioClips"
                                :key="audio.id"
                            >
                                <div
                                    class="
                                        flex
                                        gap-2
                                        items-center
                                        text-white
                                        max-w-[calc(100%-71px)]
                                    "
                                >
                                    <ion-icon
                                        name="musical-note-outline"
                                    ></ion-icon>
                                    <div
                                        class="
                                            text-white text-ellipsis
                                            whitespace-nowrap
                                            overflow-hidden
                                        "
                                    >
                                        {{ audio.title }}
                                    </div>
                                </div>
                                <div
                                    class="
                                        text-white
                                        rounded-lg
                                        bg-[#C33109]
                                        px-2
                                        py-1
                                    "
                                >
                                    {{ formatTime(audio.duration) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </pane>
            </splitpanes>
        </div>
    </div>
</template>

<script setup>
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
import { reactive, onMounted, onUnmounted, ref, watch, computed } from "vue";
import { sleep } from "../../utils/timer";
import zim, {
    Frame,
    Rectangle,
    Stage,
    Container,
    loop,
    Circle,
    Pen,
    MotionController,
    Line,
    Shape,
    Bezier,
    Squiggle,
    TransformManager,
} from "zimjs";

let videoPlayerRef;
let audioPlayerRef;
const projectVideoRefs = ref(null);
const projectAudioRefs = ref(null);

const state = reactive({
    showProjectExplorer: true,
    showClipSetting: false,
    project: null,
    selectedClip: null,
    clickTimeoutId: null,
    // Tabs
    currentTab: "video",
    videos: [],
    audios: [],
    // Timeline
    zoom: 1,
    timelineSizePx: 20,
    timelinePosition: 0,
    videoTimelineEnd: 0,
    audioTimelineEnd: 0,
    timelineFrame: 50,
    videoIntervals: [],
    audioIntervals: [],
    activeVideo: null,
    // Projects
    videoClips: [],
    audioClips: [],
    player: {
        isPlaying: false,
    },
});

const timelineEnd = computed(() => {
    return state.videoTimelineEnd > state.audioTimelineEnd
        ? state.videoTimelineEnd
        : state.audioTimelineEnd;
});

watch(
    () => state.audioClips,
    (val) => {
        state.audioTimelineEnd = 0;
        for (let i = 0; i < val.length; i++) {
            const clip = val[i];
            state.audioTimelineEnd += clip.end - clip.start;
        }
    },
    { deep: true }
);

watch(
    () => state.videoClips,
    (val) => {
        state.videoTimelineEnd = 0;
        let currentEnd = 0;
        for (let i = val.length - 1; i >= 0; i--) {
            const clip = val[i];
            if (clip.duration) {
                const _end = clip.position + clip.end - clip.start;
                if (_end > currentEnd) {
                    currentEnd = _end;
                }
            }
        }
        state.videoTimelineEnd = currentEnd;
    },
    { deep: true }
);

watch(
    () => state.audioClips,
    (val) => {
        state.audioTimelineEnd = 0;
        let currentEnd = 0;
        for (let i = val.length - 1; i >= 0; i--) {
            const clip = val[i];
            if (clip.duration) {
                const _end = clip.position + clip.end - clip.start;
                if (_end > currentEnd) {
                    currentEnd = _end;
                }
            }
        }
        state.audioTimelineEnd = currentEnd;
    },
    { deep: true }
);

let timelineInterval = null;

function onDragResourceStart(event, resource, type) {
    event.dataTransfer.setData(
        "text/plain",
        JSON.stringify({
            ...resource,
            type,
        })
    );
}

function onDropResource(event) {
    const resource = JSON.parse(event.dataTransfer.getData("text/plain"));
    if (resource.type === "video") {
        state.videoClips.push({
            resource_id: resource.id,
            type: resource.type,
            title: resource.title,
            url: resource.url,
            thumbnail: resource.thumbnail,
            order: state.videoClips.length,
        });
        const index = state.videoClips.length - 1;
        loadProjectVideo(index, 0, (resource) => {
            saveClip(resource, index);
        });
    } else if (resource.type === "audio") {
        state.audioClips.push({
            resource_id: resource.id,
            title: resource.title,
            url: resource.url,
            order: state.audioClips.length,
            type: resource.type,
        });
        const index = state.audioClips.length - 1;
        loadProjectAudio(index, 0, (resource) => {
            saveClip(resource, index);
        });
    }

    event.preventDefault();
}

function onVideoClick(resource) {
    state.videoClips.push({
        resource_id: resource.id,
        type: "video",
        title: resource.title,
        url: resource.url,
        thumbnail: resource.thumbnail,
        order: state.videoClips.length,
    });
    const index = state.videoClips.length - 1;
    loadProjectVideo(index, 0, (resource) => {
        saveClip(resource, index);
    });
}
function onAudioClick(resource) {
    state.audioClips.push({
        resource_id: resource.id,
        type: "audio",
        title: resource.title,
        url: resource.url,
        thumbnail: resource.thumbnail,
        order: state.audioClips.length,
    });
    const index = state.audioClips.length - 1;
    loadProjectAudio(index, 0, (resource) => {
        saveClip(resource, index);
    });
}

async function saveClip(resource, index) {
    const clip = await axios.post(`/project/${state.project?.id}/clips/add`, {
        resource_id: resource.resource_id,
        type: resource.type,
        position: resource.position,
        start: resource.start,
        end: resource.end,
    });
    console.log({ clip });
    if (resource.type === "video") {
        state.videoClips[index].id = clip.data.id;
    } else if (resource.type === "audio") {
        state.audioClips[index].id = clip.data.id;
    }
}

async function removeAllClips() {
    await axios.post(`/project/${state.project?.id}/clips/remove-all`);
}

async function removeClip() {
    const clip = state.selectedClip.data;
    const item =
        state.selectedClip.type === "video"
            ? state.videoClips
            : state.audioClips;
    const index = item.findIndex((c) => c.id === clip.id);
    item.splice(index, 1);
    await axios.post(
        `/project/${state.project?.id}/clips/${state.selectedClip.data?.id}/remove`
    );
}

async function loadProjectVideo(index, loop, callback) {
    if (projectVideoRefs.value && projectVideoRefs.value[index]) {
        const video = projectVideoRefs.value[index];
        var i = setInterval(function () {
            if (video.readyState > 0) {
                state.videoClips[index].duration = video.duration;
                state.videoClips[index].position = state.videoTimelineEnd;
                state.videoClips[index].start = 0;
                state.videoClips[index].end = video.duration;

                state.videoTimelineEnd =
                    video.duration + state.videoTimelineEnd;

                if (state.videoTimelineEnd > state.timelineFrame) {
                    state.timelineFrame = Math.ceil(state.videoTimelineEnd);
                }

                if (callback) {
                    callback(state.videoClips[index]);
                }

                clearInterval(i);
            }
        }, 200);

        if (index === 0) {
            state.activeVideo = index;
            videoPlayerRef = projectVideoRefs.value[index];
        }

        return;
    }
    await sleep(1000);
    loadProjectVideo(index, loop + 1, callback);
}

async function loadProjectAudio(index, loop, callback) {
    if (projectAudioRefs.value && projectAudioRefs.value[index]) {
        const audio = projectAudioRefs.value[index];
        var i = setInterval(function () {
            if (audio.readyState > 0) {
                state.audioClips[index].duration = audio.duration;
                state.audioClips[index].position = state.audioTimelineEnd;
                state.audioClips[index].start = 0;
                state.audioClips[index].end = audio.duration;

                state.audioTimelineEnd = audio.end + state.audioTimelineEnd;

                if (callback) {
                    callback(state.audioClips[index]);
                }

                clearInterval(i);
            }
        }, 200);
        return;
    }
    await sleep(1000);
    loadProjectAudio(index, loop + 1, callback);
}

async function reloadProjectVideo(index, loop) {
    const v = state.videoClips[index];
    state.videoClips[index].duration = v.end - v.start;
    state.videoClips[index].width =
        (v.end - v.start) * state.timelineSizePx * state.zoom;

    if (index === 0) {
        while (true) {
            if (projectVideoRefs.value && projectVideoRefs.value[index]) {
                state.activeVideo = index;
                videoPlayerRef = projectVideoRefs.value[index];
                break;
            }
            await sleep(200);
        }
    }
}

function reloadProjectAudio(index) {
    const v = state.audioClips[index];
    state.audioClips[index].duration = v.end - v.start;
    state.audioClips[index].width =
        (v.end - v.start) * state.timelineSizePx * state.zoom;
}

function onPlayerPlay() {
    if (state.player.isPlaying) {
        if (videoPlayerRef) {
            videoPlayerRef.pause();
        }
        if (audioPlayerRef) {
            audioPlayerRef.pause();
        }
        clearAllInterval();
    } else {
        playVideoIntervals();
        playAudioIntervals();

        timelineInterval = setInterval(() => {
            state.timelinePosition = state.timelinePosition + 0.1;
            if (state.timelinePosition >= state.videoTimelineEnd) {
                clearAllInterval();
                state.player.isPlaying = false;
            }
        }, 100);
    }
    state.player.isPlaying = !state.player.isPlaying;
}

function playVideoIntervals() {
    state.videoIntervals = [];
    for (let i = 0; i < state.videoClips.length; i++) {
        const video = state.videoClips[i];

        const start = video.position + video.start;
        const end = video.position + video.end;

        if (state.timelinePosition >= start && state.timelinePosition <= end) {
            state.activeVideo = i;
            videoPlayerRef = projectVideoRefs.value[i];
            videoPlayerRef.currentTime = state.timelinePosition + "";
            videoPlayerRef.play();

            continue;
        }
        if (state.timelinePosition > end) {
            continue;
        }
        state.videoIntervals[i] = setTimeout(() => {
            state.activeVideo = i;
            videoPlayerRef = projectVideoRefs.value[i];
            videoPlayerRef.play();
        }, (start - state.timelinePosition) * 1000);
    }
}

function playAudioIntervals() {
    state.audioIntervals = [];
    for (let i = 0; i < state.audioClips.length; i++) {
        const audio = state.audioClips[i];

        const start = audio.position + audio.start;
        const end = audio.position + audio.end;

        if (state.timelinePosition >= start && state.timelinePosition <= end) {
            state.activeAudio = i;
            audioPlayerRef = projectAudioRefs.value[i];
            audioPlayerRef.currentTime = state.timelinePosition + "";
            audioPlayerRef.play();

            continue;
        }
        if (state.timelinePosition > end) {
            continue;
        }
        state.audioIntervals[i] = setTimeout(() => {
            state.activeAudio = i;
            audioPlayerRef = projectAudioRefs.value[i];
            audioPlayerRef.play();
        }, (start - state.timelinePosition) * 1000);
    }
}

function clearAllInterval() {
    clearInterval(timelineInterval);
    for (let i = 0; i < state.videoIntervals.length; i++) {
        clearInterval(state.videoIntervals[i]);
    }

    for (let i = 0; i < state.audioIntervals.length; i++) {
        clearInterval(state.audioIntervals[i]);
    }
}

function formatTime(seconds) {
    if (!seconds) {
        return "00:00:00";
    }

    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    const formattedHrs = hrs > 0 ? String(hrs).padStart(2, "0") + ":" : "00:";
    const formattedMins = String(mins).padStart(2, "0") + ":";
    const formattedSecs = String(secs).padStart(2, "0");

    return formattedHrs + formattedMins + formattedSecs;
}

function onTimelineClick(event) {
    state.timelinePosition =
        (event.layerX - 2) / state.timelineSizePx / state.zoom;
    seek(state.timelinePosition);
}

function seek(pos) {
    state.timelinePosition = pos;
    if (videoPlayerRef) {
        videoPlayerRef.pause();
        videoPlayerRef.currentTime = pos + "";
    }
    if (audioPlayerRef) {
        audioPlayerRef.pause();
        audioPlayerRef.currentTime = pos + "";
    }
    clearAllInterval();
    state.player.isPlaying = false;

    for (let i = 0; i < state.videoClips.length; i++) {
        const video = state.videoClips[i];

        if (pos >= video.start && pos <= video.end) {
            state.activeVideo = i;
            break;
        }
    }
}

function selectClip(clip, type) {
    state.selectedClip = {
        data: clip,
        type: type,
    };
}

function isClipSelected(clip, type) {
    if (state.selectedClip?.type !== type) {
        return false;
    }

    return state.selectedClip?.data?.id === clip.id;
}

function getClipPosition(clip) {
    if (clip.position == null) {
        return state.videoTimelineEnd * state.timelineSizePx * state.zoom;
    }
    return clip.position * state.timelineSizePx * state.zoom;
}

function getClipWidth(clip) {
    if (!clip.duration) {
        return 100;
    }
    return clip.duration * state.timelineSizePx * state.zoom;
}

function editClip() {
    state.showClipSetting = true;
}

function updateclip(clip) {
    const type = clip.type;
    if (type === "video") {
        const index = state.videoClips.findIndex((c) => c.id === clip.id);
        state.videoClips[index] = clip;
        reloadProjectVideo(index, 0);
    } else if (type === "audio") {
        const index = state.audioClips.findIndex((c) => c.id === clip.id);
        state.audioClips[index] = clip;
        reloadProjectAudio(index, 0);
    }

    axios.post(`/project/${state.project?.id}/clips/update`, {
        ...clip,
    });

    state.showClipSetting = false;
    state.selectedClip = null;
}

function removeAll() {
    removeAllClips();
    state.videoClips = [];
    state.audioClips = [];
    state.timelinePosition = 0;
    state.videoTimelineEnd = 0;
    state.audioTimelineEnd = 0;
    state.timelineFrame = 50;
}

function selectProject(project) {
    state.project = project;
    getClips();
}

async function getClips() {
    try {
        const resp = await axios.get(`/project/${state.project.id}/clips`);

        if (resp.data) {
            state.videoClips = resp.data?.videos || [];
            state.audioClips = resp.data?.audios || [];

            for (let i = 0; i < state.videoClips.length; i++) {
                reloadProjectVideo(i, 0);
            }

            for (let i = 0; i < state.audioClips.length; i++) {
                reloadProjectAudio(i, 0);
            }
        }
    } catch (e) {}
}

let frame;
let stage;
let components = [];
let selectedComponent;
let color = ref(purple);
let propHeight = ref(0);
let propWidth = ref();

function resize(e) {
    console.log({ e });
    const initWidth = document.getElementById("videoWrapper")?.offsetWidth;
    const maxHeight = document.getElementById("videoWrapper")?.offsetHeight;
    console.log({ initWidth });
    propWidth.value = initWidth;
    propHeight.value = initWidth * 0.4823;

    if (propHeight.value > maxHeight) {
        propHeight.value = maxHeight;
        propWidth.value = propHeight.value / 0.4823;
    }
    document.getElementById("holderCanvas").style.width =
        propWidth.value + "px";
    document.getElementById("holderCanvas").style.height =
        propHeight.value + "px";
}

function mountCanvas() {
    window.addEventListener("resize", resize);
    setTimeout(() => {
        const initWidth = document.getElementById("videoWrapper")?.offsetWidth;
        const maxHeight = document.getElementById("videoWrapper")?.offsetHeight;
        propWidth.value = initWidth;
        propHeight.value = initWidth * 0.4823;

        if (propHeight.value > maxHeight) {
            propHeight.value = maxHeight;
            propWidth.value = propHeight.value / 0.4823;
        }
        frame = new Frame({
            scaling: "holder",
            width: propWidth.value,
            height: propHeight.value,
            mouseMoveOutside: true, // so Pen and Dial work better
            ready: () => {
                console.log("frame ready");
                zim.ZIMONON = true;
                stage = frame.stage;
                stage.enableMouseOver();

                stage.on("stagemousedown", () => {
                    selectedComponent = null;
                });
            },
        }); // end frame
    }, 1000);
}
let holder = ref(null);

onMounted(() => {
    mountCanvas();
});

onUnmounted(() => {
    clearAllInterval(timelineInterval);
});
ZIMONON = true;
function drawCircle() {
    const circle = new Circle(100, "#ffffff00", yellow, 5).center().transform({
        showReg: false,
    });
    selectedComponent = circle;
    circle.on("mousedown", (e) => {
        selectedComponent = circle;
    });
    console.log({ components });
    components.push(circle);
    stage.update();
    // this.rect.center();
    // this.stage.update();
}
</script>

<style scoped>
.sidebar button {
    flex: 1;
    flex-direction: column;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 20px;
    color: #949494;
    width: 100%;
}

.sidebar button:hover,
.sidebar button.active {
    background: #dff1ff;
    color: #2061d4;
}
.panel {
    border: 1px solid #e9ebf0;
}
.button-back {
    display: flex;
    align-items: center;
    color: #949494;
    padding: 2px 5px;
}

.button-back:hover {
    border-radius: 8px;
    background: #dff1ff;
    color: #2061d4;
}
.splitpanes.default-theme .splitpanes__pane {
    background: #fff;
}
#thumb {
    transition: left 100ms;
}
</style>
<style>
.splitpanes__splitter {
    border: none !important;
}
#holder {
    transform: translate(-50%, 0%);
}
</style>
